// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/blocks/details.scss
// module id = 54
// module chunks = 65